import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import ReactInputVerificationCode from 'react-input-verification-code';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import * as auth from '../../../../store/actions/auth';

import './styles.scss';

export default function ModalMfa({ isActive, closeModal }) {
  const tfa = useSelector((state) => state.auth.tfaStatus);

  const { i18n } = useTranslation();
  const [codeVerificationMfa, setCodeVerificationMfa] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(auth.tfaSetup());
  }, []);

  const handleOnClose = () => {
    closeModal();
    setCodeVerificationMfa('');
    setErrorMessage('');
  };

  useEffect(() => {
    if (tfa.error) {
      setCodeVerificationMfa('');
      setErrorMessage('Código errado, tente novamente!');
    } else {
      setTimeout(() => {
        handleOnClose();
      }, 500);
    }
  }, [tfa]);

  const handleCodeVerificationMfaChange = (value) => {
    setCodeVerificationMfa(value);
  };

  const handleMfaActived = () => {
    if (!codeVerificationMfa || codeVerificationMfa.length < 6) {
      setErrorMessage('Preencha todos os campos!');
      return;
    }
    dispatch(auth.tfaActive(codeVerificationMfa));
  };

  return (
    <>
      <Modal show={isActive} onHide={handleOnClose} className="modal-tag">
        <Modal.Header closeButton>
          <Modal.Title>Google Authenticator</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Para poder autorizar transações, você precisa escanear este código
            QR com seu aplicativo Google Authenticator e inserir o código de
            verificação abaixo.
          </p>
          <div className="qrBox">
            <img src={tfa.dataURL} alt="qrcode" />
          </div>

          <div className="custom-verication-code-user">
            <label htmlFor="inputCodeMfa">Código de Verificação</label>
            <ReactInputVerificationCode
              autoFocus={isActive}
              length={6}
              placeholder=""
              value={codeVerificationMfa}
              onChange={handleCodeVerificationMfaChange}
            />
            <p>{errorMessage}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            id=""
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={handleMfaActived}
          >
            {i18n.t('Ativar')}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
